// Shared style fragments for the Quick Notes picker's sub-modals — mirrors the
// mockup's .modal-head / .modal-foot / .btn-ghost / .btn-primary look.

export const modalHeaderSx = {
  padding: "16px 22px",
  borderBottom: "1px solid var(--app-border)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const modalFooterSx = {
  padding: "16px 22px",
  borderTop: "1px solid var(--app-border)",
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
};

export const closeBtnSx = {
  border: "none",
  background: "none",
  cursor: "pointer",
  fontSize: 16,
  color: "var(--app-text-muted)",
};

export const ghostBtnSx = {
  border: "1px solid var(--app-border)",
  background: "var(--app-surface)",
  borderRadius: 8,
  padding: "11px 18px",
  fontFamily: "Inter",
  fontWeight: 600,
  fontSize: 14,
  cursor: "pointer",
  color: "var(--app-text)",
  "&:hover": { background: "var(--app-surface-2)" },
};

export const primaryBtnSx = (disabled) => ({
  border: "none",
  background: "var(--app-primary)",
  borderRadius: 8,
  padding: "11px 18px",
  fontFamily: "Inter",
  fontWeight: 600,
  fontSize: 14,
  color: "var(--app-on-primary)",
  cursor: disabled ? "not-allowed" : "pointer",
  opacity: disabled ? 0.55 : 1,
  "&:hover": disabled ? {} : { filter: "brightness(.96)" },
});
